var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Checkbox, DropdownDivider, DropdownHeader, Grid, Icon, Input, Loader, Select, Table } from 'semantic-ui-react';
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import { UiConfigContext } from "../../AppConfig";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { getWithAuthn } from "../../RequestHelpers";
import { debounce } from "../automated-pro/EditKitForm";
import { getFishAmplifierCatalog, Scale } from "../automated-pro/RnaCatalog";
import { displayScaleLabel } from "../secondary-if/ProbeForm";
import { formatMonetaryDecimal, priceColumn } from "./EditKitForm";
import { abbreviateRnaWithModal, numOfBindingSites } from "./KitDisplay";
var ProbeSetForm = /** @class */ (function (_super) {
    __extends(ProbeSetForm, _super);
    function ProbeSetForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.goldExperimentVolumeTable = React.createElement(React.Fragment, null,
            "\u00A0",
            React.createElement("p", null),
            React.createElement(Table, { striped: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null, "Sample type"),
                        React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                        React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi Probe (\u00B5L)"),
                        React.createElement(Table.HeaderCell, null, "Experiments"))),
                React.createElement(Table.Body, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.Cell, null, "Sample on a slide (e.g., tissue section or adherent cells)"),
                        React.createElement(Table.Cell, null, "100"),
                        React.createElement(Table.Cell, null, "2"),
                        React.createElement(Table.Cell, null, "100")),
                    React.createElement(Table.Row, null,
                        React.createElement(Table.Cell, null,
                            "Sample in solution (e.g., whole-mount embryo",
                            !_this.props.manualPro ? " or cells in suspension" : "",
                            ")"),
                        React.createElement(Table.Cell, null, "200"),
                        React.createElement(Table.Cell, null, "4"),
                        React.createElement(Table.Cell, null, "50")),
                    !_this.props.manualPro &&
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Northern blot"),
                            React.createElement(Table.Cell, null, "2000"),
                            React.createElement(Table.Cell, null, "40"),
                            React.createElement(Table.Cell, null, "5")))));
        _this.goldProbeSetScaleLabel = React.createElement(React.Fragment, null,
            "Scale ",
            React.createElement(Help, null,
                "HCR\u2122 HiFi Probe is provided at a scale of 200 \u00B5L. For different sample types, representative reaction volumes and corresponding probe scale and number of experiments are:",
                _this.goldExperimentVolumeTable));
        _this.debounceSearchQueryChange = debounce(function (event, data) {
            _this.onSearchQueryChange(event, data);
        }, 500);
        _this.displayAndEditSequenceError = function (target) {
            return target.name !== ''
                && target.name.toLowerCase() !== "polyA".toLowerCase()
                && target.targetMrnaSeq.length < 15
                && target.targetMrnaSeq.length > 0;
        };
        _this.displayAndEditSequenceWarning = function (target) {
            return (target.name !== ''
                && target.targetMrnaSeq.length < 600
                && target.targetMrnaSeq.length > 0
                && _this.props.legacy ||
                target.name !== ''
                    && target.targetMrnaSeq.length < 600
                    && target.targetMrnaSeq.length > 51
                    && !_this.props.legacy);
        };
        _this.displayShortTargetMessage = function (target) {
            return target.name !== ''
                && target.targetMrnaSeq.length >= 15
                && target.targetMrnaSeq.length <= 51
                && !_this.props.legacy;
        };
        _this.effectiveTargets = function () {
            var exactMatchFamilies = _this.props.probeSetState.targets.filter(function (psf) {
                return _this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.props.probeSetState.searchQuery);
            });
            var synonymFamilies = _this.props.probeSetState.targets.filter(function (psf) {
                return _this.searchQueryIsSynonymForProbeSetFamily(psf, _this.props.probeSetState.searchQuery);
            });
            var otherProbeSetFamilies = _this.props.probeSetState.targets.filter(function (psf) {
                return !_this.searchQueryIsSynonymForProbeSetFamily(psf, _this.props.probeSetState.searchQuery) &&
                    !_this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.props.probeSetState.searchQuery);
            });
            var options = [];
            options = options.concat((exactMatchFamilies.length > 0 || synonymFamilies.length > 0) ? [
                React.createElement(DropdownHeader, { key: 'recommended-header', content: 'Recommended' }),
                React.createElement(DropdownDivider, { key: 'recommended-divider' })
            ] : []).concat(exactMatchFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    f.description.length > 0 ? "(" + f.description + ")" : '');
                var text = symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat(synonymFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    f.description.length > 0 ? "(" + f.description + ")" : '');
                var text = symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat((otherProbeSetFamilies.length !== 0 && _this.props.probeSetState.searchQuery !== '') ? [
                React.createElement(DropdownHeader, { key: 'other-header', content: "Other Results for " + _this.props.probeSetState.searchQuery }),
                React.createElement(DropdownDivider, { key: 'other-divider' })
            ]
                : []).concat(otherProbeSetFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    f.description.length > 0 ? "(" + f.description + ")" : '');
                var text = symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat((_this.props.probeSetState.target.id === -1 && _this.props.probeSetState.target.name.trim() !== "") ? [
                {
                    text: _this.props.probeSetState.target.name,
                    value: -1
                }
            ] : []);
            return options;
        };
        _this.searchQueryIsSynonymForProbeSetFamily = function (f, searchQuery) {
            return !!f.synonyms.find(function (s) { return s.toLowerCase() === searchQuery.toLowerCase(); });
        };
        _this.searchQueryIsExactMatchToProbeSetFamily = function (f, searchQuery) {
            return f.geneSymbol.toLowerCase() === searchQuery.toLowerCase();
        };
        _this.probeSetSizeOptions = function (targetMrnaSeq) {
            return _this.props.catalog.probeSet.custom.probeSetSizes.filter(function (s) {
                if (targetMrnaSeq.length === 0) {
                    return s === 20;
                }
                else if (targetMrnaSeq.length < 52) {
                    return s === 1;
                }
                else if (targetMrnaSeq.length < 1092) {
                    return s === 20;
                }
                else {
                    return (s === 20 || s === 40);
                }
            }).map(function (s) {
                var label = React.createElement(React.Fragment, null,
                    React.createElement("span", null, s > 20 ? "Boosted" : (s === 1 ? "Special" : "Standard")),
                    React.createElement("span", { className: 'description' }, targetMrnaSeq.length > 0 ? (s !== 1 ? "Up to " + s : s) : ""));
                return {
                    text: label,
                    value: s
                };
            });
        };
        _this.customTargetProbeSetSizeInput = function () {
            var options = _this.probeSetSizeOptions(_this.props.probeSetState.target.targetMrnaSeq);
            var inputNode = React.createElement(Select, { name: 'probe-set-size', className: options.length <= 1 ? "deactivated-dropdown" : "selection-dropdown", onChange: _this.onCustomProbeSetRestrictedSizeChange, options: options, icon: options.length <= 1 ? false : undefined, value: _this.props.probeSetState.target.probeSetSize });
            return React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeSet/customParams/probeSetSize', errors: _this.props.errors, labelContent: numberOfBindingSites, showErrors: _this.props.showErrors, labelFor: 'probe-set-size' }, inputNode);
        };
        _this.onOrganismChange = function (_, data) {
            var organism = data.value;
            var selectedOrganism = _this.props.catalog.probeSet.catalog.organisms
                .find(function (o) { return o.id === organism; });
            _this.props.onProbeSetChange(function () {
                return {
                    organism: new EditableOrganism(selectedOrganism ? selectedOrganism.name : "", selectedOrganism ? selectedOrganism.scientificName : "", selectedOrganism ? selectedOrganism.id : EditableOrganism.default().id),
                    negativeControlProbe: (selectedOrganism === null || selectedOrganism === void 0 ? void 0 : selectedOrganism.name.toLowerCase()) === "bacillus subtilis"
                        ? false
                        : _this.props.probeSetState.negativeControlProbe,
                    target: EditableTarget.default(_this.probeSetSizeOptions(_this.props.probeSetState.target.targetMrnaSeq)[0].value),
                    targets: [],
                    editSequenceOn: false
                };
            }, _this.props.probeSetState.hcrAmplifier, _this.props.onUserSelection);
        };
        _this.onAddCustomOrganism = function (_, data) {
            var str = data.value;
            _this.props.onProbeSetChange({
                organism: new EditableOrganism(str, "", -1),
                negativeControlProbe: str.toLowerCase() === "bacillus subtilis" ? false : _this.props.probeSetState.negativeControlProbe
            }, _this.props.probeSetState.hcrAmplifier, _this.props.onUserSelection);
        };
        _this.onSearch = function (options, value) {
            if (value.trim().length === 0) {
                return [];
            }
            else {
                return uniqueBy(options, function (o) { return o.value; });
            }
        };
        _this.onSearchChange = function (event, data) {
            if (_this.props.probeSetState.organism.id !== -1 && data.searchQuery.length !== 0) {
                // Call the debounced function
                _this.debounceSearchQueryChange(event, data);
            }
        };
        _this.onSearchQueryChange = function (_, data) {
            var path = "";
            if (data.searchQuery.length === 0) {
                _this.props.onProbeSetChange(function () { return ({
                    targets: [],
                    searchQuery: "",
                    target: data.searchQuery.length === 0
                        ? EditableTarget.default(-1)
                        : _this.props.probeSetState.target
                }); }, _this.props.probeSetState.hcrAmplifier);
                return;
            }
            path = "/rna/search/id/" +
                (encodeURIComponent(_this.props.probeSetState.organism.id) + "/targetGene/") +
                ("" + encodeURIComponent(data.searchQuery));
            _this.props.onProbeSetChange(function () { return ({
                searchLoading: true
            }); }, _this.props.probeSetState.hcrAmplifier, function () {
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    _this.props.onProbeSetChange(function () {
                        if (resp !== undefined) {
                            return {
                                searchLoading: false,
                                searchQuery: data.searchQuery,
                                targets: resp.probeSetFamilyResults
                            };
                        }
                        else {
                            return {
                                searchLoading: false,
                                searchQuery: data.searchQuery
                            };
                        }
                    }, _this.props.probeSetState.hcrAmplifier, _this.props.onUserSelection);
                });
            });
        };
        _this.onAddCustomTarget = function (_, data) {
            var ct = data.value;
            _this.props.onProbeSetChange({
                target: new EditableTarget(ct, "", "", "", _this.probeSetSizeOptions(_this.props.probeSetState.target.targetMrnaSeq)[0].value, -1),
                editSequenceOn: true
            }, _this.props.probeSetState.hcrAmplifier, _this.props.onUserSelection);
        };
        _this.noOrganismSelected = function () {
            var organism = _this.props.probeSetState.organism;
            return organism.id === -1 && organism.name.trim() === "";
        };
        _this.noTargetSelected = function () {
            var target = _this.props.probeSetState.target;
            return target.id === -1 && target.name.trim() === "";
        };
        _this.onTargetChange = function (_, data) {
            if (typeof data.value === "number") {
                _this.props.onProbeSetChange(function () { return ({
                    searchLoading: true
                }); }, _this.props.probeSetState.hcrAmplifier, function () {
                    getWithAuthn("/rna/search/probeSetFamilyId/" + encodeURIComponent(data.value))
                        .then(function (resp) {
                        if (resp.status === 200) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (jsonFamily) {
                        if (jsonFamily !== undefined && jsonFamily.psf != null) {
                            _this.props.onProbeSetChange(function () {
                                var _a;
                                // get the first variant with the same probe set size
                                var probeSetFamily = jsonFamily.psf;
                                var variant = probeSetFamily.variants.find(function (v) {
                                    return v.probeSetSize === _this.props.probeSetState.target.probeSetSize;
                                });
                                if (variant == null) {
                                    variant = probeSetFamily.variants.find(function (v) {
                                        return v.id === probeSetFamily.defaultVariant.id;
                                    });
                                }
                                var accession = variant ? (variant.accession ? variant.accession.transcriptAccession : "") : "";
                                var targetSequence = variant ? (variant.targetMrnaSeq) : "";
                                var probeSetSizeLookup = (_a = _this.probeSetSizeOptions(targetSequence).find(function (s) {
                                    return s.value === _this.props.probeSetState.target.probeSetSize;
                                })) === null || _a === void 0 ? void 0 : _a.value;
                                var probeSetSize = probeSetSizeLookup ? probeSetSizeLookup : _this.probeSetSizeOptions(targetSequence)[0].value;
                                // const assignableProbeDesign = probeSetFamily.variants.find((v) => {
                                //     return v.probeSetSize === probeSetSize &&
                                //         v.targetMrnaSeq === targetSequence
                                // })
                                return {
                                    searchLoading: false,
                                    target: new EditableTarget(probeSetFamily.geneSymbol, probeSetFamily.description, accession, targetSequence, probeSetSize, probeSetFamily.id),
                                    editSequenceOn: false
                                };
                            }, _this.props.probeSetState.hcrAmplifier, _this.props.onUserSelection);
                        }
                        else {
                            _this.props.onProbeSetChange(function () {
                                return {
                                    searchLoading: false,
                                    targets: [],
                                    target: EditableTarget
                                        .default(_this.probeSetSizeOptions("")[0].value),
                                    searchQuery: "",
                                    editSequenceOn: true
                                };
                            }, _this.props.probeSetState.hcrAmplifier, _this.props.onUserSelection);
                        }
                    });
                });
            }
            else {
                _this.props.onProbeSetChange(function () {
                    return {
                        searchLoading: false,
                        variant: undefined,
                        target: EditableTarget.default(-1),
                        searchQuery: "",
                        targets: [],
                    };
                }, _this.props.probeSetState.hcrAmplifier, _this.props.onUserSelection);
            }
        };
        _this.onRnaSeqChange = function (event) {
            var s = event.currentTarget.value;
            _this.setCustomTargetState(function (t) {
                var sequence = cleanUpRnaSeq(s);
                return t.withRna(sequence, _this.probeSetSizeOptions(sequence).map(function (size) { return size.value; }));
            });
        };
        _this.displayEditAndSave = function () {
            if (_this.props.probeSetState.target.targetMrnaSeq.length === 0) {
                return _this.props.probeSetState.editSequenceOn
                    ? React.createElement("a", { style: { cursor: 'pointer' }, onClick: _this.onEditSequenceClick }, "Save")
                    : React.createElement(React.Fragment, null,
                        React.createElement("a", { style: { cursor: 'pointer' }, onClick: _this.onEditSequenceClick }, "Edit"));
            }
            else {
                return _this.props.probeSetState.editSequenceOn
                    ? React.createElement("a", { style: { cursor: 'pointer' }, onClick: _this.onEditSequenceClick }, "Save")
                    : React.createElement(React.Fragment, null,
                        React.createElement("a", { style: { cursor: 'pointer' }, onClick: _this.onEditSequenceClick }, "Edit"),
                        "\u00A0\u00A0",
                        _this.props.probeSetState.sequenceSaveButton === 'Copied!' ? React.createElement(React.Fragment, null, "Copied!") :
                            React.createElement("a", { style: { cursor: 'pointer' }, onClick: _this.onCopyClick }, _this.props.probeSetState.sequenceSaveButton));
            }
        };
        _this.onEditSequenceClick = function () {
            _this.props.onProbeSetChange(function () {
                return {
                    editSequenceOn: !_this.props.probeSetState.editSequenceOn
                };
            }, _this.props.probeSetState.hcrAmplifier);
        };
        _this.onCopyClick = function () {
            var n = navigator;
            n.clipboard.writeText(_this.props.probeSetState.target.targetMrnaSeq)
                .then(function () {
                _this.props.onProbeSetChange(function () {
                    return {
                        sequenceSaveButton: 'Copied!'
                    };
                }, _this.props.probeSetState.hcrAmplifier);
                setTimeout(function () { return _this.props.onProbeSetChange(function () {
                    return {
                        sequenceSaveButton: 'Copy'
                    };
                }, _this.props.probeSetState.hcrAmplifier); }, 2000);
            })
                .catch(function (e) {
                console.log("Could not copy: " + e);
            });
        };
        _this.onCustomProbeSetRestrictedSizeChange = function (_, data) {
            var v = data.value;
            var found = _this.props.catalog.probeSet.custom.probeSetSizes.find(function (s) { return s === v; });
            if (found !== undefined) {
                _this.setCustomTargetState(function (t) { return t.withProbeSetSize(found); }, _this.props.onUserSelection);
            }
            else {
                throw new Error("Unexpected probe size " + v);
            }
        };
        // private readonly onCustomProbeSetFlexibleSizeChange = (_: React.SyntheticEvent<HTMLElement>,
        //                                                        data: InputOnChangeData) => {
        //     const v = data.value;
        //
        //     const num = parseInt(v, 10);
        //     if (isNaN(num)) {
        //         // no op -- discard input
        //         return
        //     }
        //
        //     this.setCustomTargetState((t) => t.withProbeSetSize(num), this.props.onUserSelection);
        // };
        _this.onProbeSetScaleChange = function (_, data) {
            var v = data.value;
            var newScale = _this.effectiveProbeSetScales().find(function (s) { return s.scaleValue === v; });
            if (newScale === undefined) {
                if (!_this.props.enableCustomScale) {
                    throw new RangeError("Unknown scale value " + v);
                }
                if (typeof v !== 'string') {
                    throw new Error("Invalid scale " + v);
                }
                var num = parseInt(v, 10);
                if (num === undefined || isNaN(num)) {
                    throw new Error("Invalid scale " + v);
                }
                newScale = new Scale(num);
            }
            _this.props.onProbeSetChange({
                scale: newScale
            }, _this.props.probeSetState.hcrAmplifier, _this.props.onUserSelection);
        };
        _this.onAmplifierChange = function (_, data) {
            var valStr = data.value;
            var prevAmplifier = _this.props.probeSetState.hcrAmplifier;
            var a = getFishAmplifierCatalog(_this.props.legacy, _this.props.catalog).channels.find(function (amp) { return amp.hcrAmplifier.id === valStr; });
            if (a === undefined) {
                throw new RangeError("Invalid amplifier " + valStr);
            }
            _this.props.onProbeSetChange(function () {
                return {
                    hcrAmplifier: a.hcrAmplifier
                };
            }, prevAmplifier, _this.props.onUserSelection);
        };
        _this.onToggleNegativeControl = function (_) {
            _this.props.onProbeSetChange(function (oldState) {
                return {
                    negativeControlProbe: !oldState.negativeControlProbe
                };
            }, _this.props.probeSetState.hcrAmplifier, _this.props.onUserSelection);
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onProbeSetChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, _this.props.probeSetState.hcrAmplifier, callback);
        };
        _this.setCustomTargetState = function (t, callback) {
            _this.props.onProbeSetChange({
                target: t(_this.props.probeSetState.target)
            }, _this.props.probeSetState.hcrAmplifier, callback);
        };
        _this.effectiveProbeSetScales = function () {
            var scales = _this.props.catalog.probeSet.catalog.fishScales;
            if (_this.props.enableCustomScale) {
                if (scales.findIndex(function (p) { return p.scaleValue === _this.props.probeSetState.scale.scaleValue; }) < 0) {
                    scales.push(new Scale(_this.props.probeSetState.scale.scaleValue));
                }
            }
            return scales.sort(function (s1, s2) { return s1.scaleValue - s2.scaleValue; });
        };
        // The catalog lists every eukaryote NCBI annotates, a few thousand organisms, so rather than let Semantic
        // substring-filter and render the whole list on each keystroke we rank the matches and show the best 25:
        // names starting with the query first, then any word (e.g. "mouse" in "House mouse"), then anything containing it.
        _this.onOrganismSearch = function (options, query) {
            var q = query.trim().toLowerCase();
            if (q.length === 0) {
                return options;
            }
            var rank = function (o) {
                var _a;
                var text = String((_a = o.text) !== null && _a !== void 0 ? _a : '').toLowerCase();
                if (text.startsWith(q)) {
                    return 0;
                }
                if (text.split(/[\s(]+/).some(function (word) { return word.startsWith(q); })) {
                    return 1;
                }
                return text.includes(q) ? 2 : -1;
            };
            return options
                .map(function (o) { return ({ o: o, r: rank(o) }); })
                .filter(function (_a) {
                var r = _a.r;
                return r >= 0;
            })
                .sort(function (a, b) { return a.r - b.r || String(a.o.text).localeCompare(String(b.o.text)); })
                .slice(0, 25)
                .map(function (_a) {
                var o = _a.o;
                return o;
            });
        };
        _this.effectiveOrganisms = function () {
            var organisms = _this.props.catalog.probeSet.catalog.organisms.map(function (o) {
                var scientificName = o.scientificName.length > 0 && o.scientificName !== o.name ? "(" + o.scientificName + ")" : '';
                return {
                    text: (o.name + " " + scientificName).trim(),
                    content: (o.name + " " + scientificName).trim(),
                    value: o.id
                };
            });
            if (_this.props.probeSetState.organism.id === -1 && _this.props.probeSetState.organism.name.trim() !== "") {
                organisms = organisms.concat([
                    {
                        text: _this.props.probeSetState.organism.name,
                        content: _this.props.probeSetState.organism.name,
                        value: _this.props.probeSetState.organism.id
                    }
                ]);
            }
            return uniqueBy(organisms, function (o) { return o.value; });
        };
        return _this;
    }
    ProbeSetForm.prototype.render = function () {
        var _this = this;
        var organism = this.props.probeSetState.organism;
        var target = this.props.probeSetState.target;
        var orgLabel = React.createElement(React.Fragment, null,
            "Organism ",
            React.createElement(Help, null,
                React.createElement("p", null, "Select the organism for your experiment or type the name of your organism if it is not in our Infinite Catalog.")));
        var probeSetLabel = React.createElement(React.Fragment, null,
            "Target ",
            React.createElement(Help, null,
                React.createElement("p", null, "Enter the name of the target RNA for your experiment. For Organisms in our Infinite Catalog, you will see suggested matches as you type, each accompanied by an optimized sequence from NCBI."),
                React.createElement("p", null,
                    "If your target is not listed in our Infinite Catalog, type the gene symbol corresponding to your target RNA. For example, enter gene symbol \u201Csox10\u201D for the gene named \u201CSRY (sex determining region Y)-box 10\u201D in organism ",
                    React.createElement("em", null, "Danio rerio"),
                    ". You can look up gene symbols on ",
                    React.createElement("a", { href: "https://www.ncbi.nlm.nih.gov/" }, "NCBI"),
                    "."),
                React.createElement("p", null,
                    "Whether your target is already in the Infinite Catalog or just joining it, ",
                    this.props.legacy ? "HCR™ Probes (v3.0) " : "HCR™ HiFi Probes ",
                    "are designed by the MI Team using MI\u2019s proprietary probe design process with no design fee.")));
        var probeSetScaleOptions = this.effectiveProbeSetScales().map(function (s) {
            var numberOfSamples = calculateNumOfSamplesForProbeSet(s.scaleValue);
            var numberOfSlides = calculateNumOfSlidesForProbeSet(s.scaleValue);
            var volumeLabel = _this.props.legacy ? s.pmolWithUnits : s.scaleWithUnits;
            return displayScaleLabel(s.scaleValue, numberOfSamples, numberOfSlides, volumeLabel, _this.props.selectedSampleType);
        });
        var fishAmplifierDropdownText = function () {
            return getFishAmplifierCatalog(_this.props.legacy, _this.props.catalog).channels.map(function (a) {
                return {
                    text: a.hcrAmplifier.id,
                    value: a.hcrAmplifier.id
                };
            });
        };
        var proAmplifierOption = function () {
            var cishAmp = _this.props.catalog.proAmplifier;
            var amplifiers;
            // Check if it's admin catalog (has hcrAmplifiers property)
            if ('hcrAmplifiers' in cishAmp) {
                // Admin catalog - use hcrAmplifiers directly
                amplifiers = cishAmp.userConfigs.manualProAmps.proAmpConfigList.map(function (config) { return config.amplifier; });
            }
            else {
                // Consumer catalog - extract unique amplifiers from manualProAmps
                amplifiers = cishAmp.manualProAmps.proAmpConfigList.map(function (config) { return config.amplifier; });
            }
            // Return dropdown options
            return amplifiers.map(function (amp) { return ({
                text: amp.id,
                value: amp.id
            }); });
        };
        // returns true if the org is "Bacillus subtilis", useful because when this is the case
        // the negative control probe toggle in not available
        var probeIsBacillus = function () {
            return _this.props.probeSetState.organism.name.toLowerCase() === "bacillus subtilis";
        };
        return React.createElement(Grid, { columns: 4, stackable: true },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeSet/otherOrganism/name', errors: this.props.errors, labelContent: orgLabel, labelFor: 'generic-organism', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'generic-organism', type: 'text', onBlur: this.props.onUserSelection, options: this.effectiveOrganisms(), search: this.onOrganismSearch, icon: false, onChange: this.onOrganismChange, additionLabel: 'Custom Organism: ', additionPosition: "bottom", placeholder: 'Select or enter new...', allowAdditions: true, clearable: true, selectOnNavigation: false, selectOnBlur: false, onAddItem: this.onAddCustomOrganism, value: this.noOrganismSelected() ? "" : organism.id })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeSet/customTarget/name', errors: this.props.errors, labelContent: probeSetLabel, labelFor: 'target-custom', showErrors: this.props.showErrors },
                        React.createElement(Select, { additionLabel: "Custom Target: ", additionPosition: "bottom", allowAdditions: true, onAddItem: this.onAddCustomTarget, icon: false, clearable: true, disabled: organism.name.trim().length === 0, className: 'gene-symbol', loading: this.props.probeSetState.searchLoading, type: 'text', name: 'target-custom', onBlur: this.props.onUserSelection, onChange: this.onTargetChange, onSearchChange: this.onSearchChange, selectOnNavigation: false, selectOnBlur: false, options: this.noOrganismSelected() ? [] : this.effectiveTargets(), placeholder: 'Enter target (e.g., tpm3)', search: this.onSearch, spellCheck: false, value: this.noTargetSelected() ? "" : target.id }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeSet/customTarget/targetMrnaSeq', errors: this.props.errors, showErrors: this.props.showErrors && !this.displayAndEditSequenceError(target), wrapLabelContent: true, labelContent: React.createElement(React.Fragment, null,
                            "RNA target sequence ",
                            target.targetMrnaSeq.length > 0
                                ? "(" + target.targetMrnaSeq.length + " nt) "
                                : '',
                            React.createElement(Help, null, rnaHelp),
                            !this.displayAndEditSequenceError(target) && this.displayEditAndSave()), labelFor: 'rna-target-seq' }, this.props.probeSetState.editSequenceOn ? React.createElement(Input, { name: 'rna-target-seq', onBlur: this.props.onUserSelection, onChange: this.onRnaSeqChange, style: { 'fontFamily': 'monospace' }, placeholder: 'Enter target sequence (e.g., CUCGGA...)', value: target.targetMrnaSeq }) : abbreviateRnaWithModal(target.targetMrnaSeq, false))),
                this.displayAndEditSequenceWarning(target)
                    && React.createElement(Grid.Column, { style: { paddingTop: '1.9rem' } },
                        React.createElement(Icon, { style: { 'color': '#333333' }, name: 'clipboard outline' }),
                        React.createElement("em", { style: { 'color': '#333333' } }, "The sequence that you input is less than 600-nt. Our team will work to optimize the number of binding sites for this target, but this may result in a loss of sensitivity for your probe.")),
                this.displayAndEditSequenceError(target)
                    && React.createElement(Grid.Column, { style: { paddingTop: '1.9rem' } },
                        React.createElement(Icon, { color: 'red', name: 'exclamation triangle' }),
                        React.createElement("em", null, "sequence must be > 14 nt")),
                this.displayShortTargetMessage(target)
                    && React.createElement(Grid.Column, { style: { paddingTop: '1.9rem' } },
                        React.createElement("em", null,
                            "HCR\u2122 HiFi Probes for short target detection are now available! ",
                            this.props.selectedSampleType.id === 'NORTHERN_BLOT'
                                ? React.createElement(React.Fragment, null,
                                    "Contact ",
                                    React.createElement("a", { href: "mailto:support@molecularinstruments.com?subject=Short Target Detection for Northern Blots" }, "us"),
                                    " for more information.")
                                : React.createElement(React.Fragment, null,
                                    "Access the User Guide ",
                                    !this.props.manualPro ? React.createElement("a", { href: this.props.selectedSampleType.id === 'CELLS_SUSPENSION'
                                            ? "https://cdn.prod.website-files.com/633286c697eb812511d7dabf/6a1a20f15096daa2e93120cf_HCR%E2%84%A2-Gold-RNA-Flow-Cytometry-User-Guide-2-Component-Probe.pdf"
                                            : "https://cdn.prod.website-files.com/633286c697eb812511d7dabf/6a39f7d52462d09011bcfd5b_HCR™-Gold-RNAFISH-User-Guide-2-Component-Probe.pdf", target: "_blank", rel: "noopener noreferrer" }, "here") : React.createElement("a", { href: "https://cdn.prod.website-files.com/633286c697eb812511d7dabf/6a39f7d5f498168e10184b08_HCR™-Pro-RNAISH-User-Guide-2-Component-Probe.pdf", target: "_blank", rel: "noopener noreferrer" }, " here "),
                                    ".")))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/probeSet/customParams/hcrAmplifier', errors: this.props.errors, labelContent: this.props.legacy ? legacyAmplifierLabel : this.props.manualPro ? proAmplifierLabel : goldAmplifierLabel, showErrors: this.props.showErrors, labelFor: 'amp-hcr' },
                        React.createElement(Select, { className: "label-dropdown amp-dropdown", disabled: this.props.amplifierDropdownDisabled, value: this.props.probeSetState.hcrAmplifier.id, onChange: this.onAmplifierChange, options: this.props.manualPro ? proAmplifierOption() : fishAmplifierDropdownText(), name: 'amp-hcr' }))),
                React.createElement(Grid.Column, null, this.customTargetProbeSetSizeInput()),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/probeSetComponent/scalePmol', errors: this.props.errors, labelContent: this.props.legacy ? legacyProbeSetScaleLabel : this.goldProbeSetScaleLabel, labelFor: 'probe-set-scale' },
                        React.createElement(Select, { className: 'label-dropdown', name: 'probe-set-scale', onChange: this.onProbeSetScaleChange, allowAdditions: this.props.enableCustomScale, search: true, options: probeSetScaleOptions, value: this.props.probeSetState.scale.scaleValue }))),
                (!this.props.enableNegativeControlProbe || probeIsBacillus()) && priceColumn(React.createElement(ComponentPriceDisplay, { loading: this.props.priceLoading, effectivePriceCents: this.props.effectivePriceCents, listPriceCents: this.props.listPriceCents }), this.props.effectivePriceCents !== this.props.listPriceCents)),
            (this.props.enableNegativeControlProbe && !probeIsBacillus()) && React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 12 },
                    React.createElement("div", { style: { display: 'inline-flex', gap: '0.5rem', fontWeight: 600 } },
                        React.createElement(Checkbox, { checked: this.props.probeSetState.negativeControlProbe, onChange: this.onToggleNegativeControl, label: React.createElement("label", null,
                                this.props.legacy ? "Add HCR™ Negative Control Probe (v3.0) (+$100 for 50 µL)" : "Add HCR™ HiFi Negative Control Probe (+$100 for 50 µL)",
                                ' ',
                                React.createElement("span", { onClick: function (e) {
                                        e.stopPropagation(); // prevent label click
                                    } },
                                    React.createElement(Help, null, "Add a validated negative control probe for robust quality control. The HCR\u2122 HiFi Negative Control Probe targets sequences that are not native to non-bacterial species, helping you distinguish true signal from background and evaluate assay specificity in your HCR\u2122 RNA-ISH experiments."))) }))),
                priceColumn(React.createElement(ComponentPriceDisplay, { loading: this.props.priceLoading, effectivePriceCents: this.props.enabled && this.props.probeSetState.negativeControlProbe && this.props.effectivePriceCents != null
                        ? this.props.effectivePriceCents + 10000
                        : this.props.effectivePriceCents, listPriceCents: this.props.enabled && this.props.probeSetState.negativeControlProbe && this.props.listPriceCents != null
                        ? this.props.listPriceCents + 10000
                        : this.props.listPriceCents }), this.props.effectivePriceCents !== this.props.listPriceCents)),
            this.props.enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: this.props.probeSetState.customPrice, defaultEffectivePriceCents: this.props.effectivePriceCents, errors: this.props.errors, errorPathPrefix: '/probeSetComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    // The first column of rna buffer form's help table
    ProbeSetForm.experimentVolumeTable = React.createElement(React.Fragment, null,
        "\u00A0",
        React.createElement("p", null),
        React.createElement(Table, { striped: true, celled: true },
            React.createElement(Table.Header, null,
                React.createElement(Table.Row, null,
                    React.createElement(Table.HeaderCell, null, "Sample type"),
                    React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"))),
            React.createElement(Table.Body, null,
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, "Whole-Mount zebrafish larvae (5 dpf)"),
                    React.createElement(Table.Cell, null, "500")),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, "Whole-Mount nematode larvae (L3)"),
                    React.createElement(Table.Cell, null, "500")),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, "Whole-Mount sea urchin embryos (45 hpf)"),
                    React.createElement(Table.Cell, null, "100")),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, "Whole-Mount fruit fly embryos (stage 4-6)"),
                    React.createElement(Table.Cell, null, "200")),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, "Whole-Mount chicken embryos (stage HH 11-12)"),
                    React.createElement(Table.Cell, null, "500")),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, "Whole-Mount mouse embryos (E9.5)"),
                    React.createElement(Table.Cell, null, "500")),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, "Mammalian cells on a chambered slide"),
                    React.createElement(Table.Cell, null, "300")),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, "Bacteria in suspension"),
                    React.createElement(Table.Cell, null, "500")),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, "Mammalian cells in suspension"),
                    React.createElement(Table.Cell, null, "500")),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null, "Tissue Section (FFPE or fresh/fixed frozen) on a slide"),
                    React.createElement(Table.Cell, null, "100")),
                React.createElement(Table.Row, null,
                    React.createElement(Table.Cell, null,
                        "Northern Blots (9 cm",
                        React.createElement("sup", null, "2"),
                        " membrane)"),
                    React.createElement(Table.Cell, null, "1500")))));
    return ProbeSetForm;
}(React.PureComponent));
export default ProbeSetForm;
;
// An "other" organism with extras for use by kit edit UI.
var EditableOrganism = /** @class */ (function () {
    function EditableOrganism(name, scientificName, id) {
        this.name = name;
        this.scientificName = scientificName;
        this.id = id;
    }
    EditableOrganism.prototype.displayName = function () {
        return this.name + " " + (this.scientificName.length > 0 && this.scientificName !== this.name ? '(' + this.scientificName + ')' : '');
    };
    EditableOrganism.default = function () {
        return new EditableOrganism('', '', -1);
    };
    EditableOrganism.fromLibOrg = function (libOrg) {
        return libOrg ? new EditableOrganism(libOrg.name, libOrg.scientificName, libOrg.id) : EditableOrganism.default();
    };
    return EditableOrganism;
}());
export { EditableOrganism };
// kits "target" and "params" into one type because it doesn't really benefit us here to have them split
var EditableTarget = /** @class */ (function () {
    function EditableTarget(name, description, accession, rnaSeq, probeSetSize, id, variantId) {
        this.name = name;
        this.description = description;
        this.accession = accession;
        this.targetMrnaSeq = rnaSeq;
        this.probeSetSize = probeSetSize;
        this.id = id;
        this.variantId = variantId;
    }
    // use old-style method syntax so Jest matchers allow equality
    EditableTarget.prototype.withRna = function (r, probeSetSizeOptions) {
        var _this = this;
        if (probeSetSizeOptions.find(function (s) { return s === _this.probeSetSize; })) {
            return new EditableTarget(this.name, this.description, "", r, this.probeSetSize, this.id, undefined);
        }
        else {
            return new EditableTarget(this.name, this.description, "", r, probeSetSizeOptions[0], this.id, undefined);
        }
    };
    ;
    EditableTarget.prototype.withProbeSetSize = function (s) {
        return new EditableTarget(this.name, this.description, this.accession, this.targetMrnaSeq, s, this.id, undefined);
    };
    ;
    EditableTarget.prototype.withProbeDesign = function (variantId) {
        return new EditableTarget(this.name, this.description, this.accession, this.targetMrnaSeq, this.probeSetSize, this.id, variantId);
    };
    EditableTarget.prototype.displayName = function () {
        return this.name + " " + (this.description.length > 0 ? '(' + this.description + ')' : '');
    };
    EditableTarget.prototype.serializationName = function () {
        return "" + this.name;
    };
    EditableTarget.default = function (probeSetSize) {
        return new EditableTarget('', '', '', '', probeSetSize, -1);
    };
    EditableTarget.fromLibTarget = function (libVariant, probeSetSize) {
        return new EditableTarget(libVariant.probeSetFamily.geneSymbol, libVariant.probeSetFamily.description, libVariant.accession
            ? libVariant.accession.transcriptAccession : "", libVariant.targetMrnaSeq, numOfBindingSites(probeSetSize), libVariant.probeSetFamily.id, undefined
        // libVariant.id
        );
    };
    return EditableTarget;
}());
export { EditableTarget };
/**
 *
 * @param items Array of items
 * @param comparableExtractor Function to extract the thing to compare by from each item. It should be something that
 * JS knows how to compare equality on, like a primitive.
 */
export function uniqueBy(items, comparableExtractor) {
    return items.filter(function (item, index) {
        // Only keep the first thing that's considered equal to the current item
        return items.findIndex(function (other) { return comparableExtractor(other) === comparableExtractor(item); }) === index;
    });
}
var rnaHelp = React.createElement(React.Fragment, null,
    React.createElement("p", null, "If your target is part of our Infinite Catalog, you can leave the sequence unmodified to proceed with an optimized target sequence from NCBI, or you can edit the sequence if desired."),
    React.createElement("p", null,
        "If your target is not listed in our Infinite Catalog, enter the sequence for your target RNA (only A,C,G,U are allowed; T will be converted to U) including 5' and 3' UTRs. Please email ",
        React.createElement("a", { href: "mailto:support@molecularinstruments.com" }, "support@molecularinstruments.com"),
        " if you have any questions."));
var legacyAmplifierLabel = React.createElement(React.Fragment, null,
    "For use with amplifier ",
    React.createElement(Help, null, "Specify the HCR\u2122 Amplifier (v3.0) that you will use with your probe. For multiplex experiments, choose a different HCR\u2122 Amplifier (v3.0) (B1, B2, \u2026) for each target that will be imaged in the same sample (for example, amplifier B1 for target 1, amplifier B2 for target 2, \u2026)."));
var goldAmplifierLabel = React.createElement(React.Fragment, null,
    "For use with amplifier ",
    React.createElement(Help, null,
        React.createElement("p", null, "Specify the HCR\u2122 Gold Amplifier that you will use with your HCR\u2122 HiFi Probe. For multiplex experiments, choose a different HCR\u2122 Gold Amplifier (X1, X2, \u2026) for each target that will be imaged in the same sample (for example, amplifier X1 for target 1, amplifier X2 for target 2, \u2026)."),
        React.createElement("p", null, "For flexibility, 488, 546, 594, and 647 are available across all X1-X10 systems. For expanded channel options, select amplifiers also offer an additional unique label option. We recommend using a longer-wavelength label (e.g., 647 or 750) for targets that are more difficult to detect (e.g., low-expression targets), as autofluorescence tends to be higher in shorter-wavelength channels (e.g., 405 or 488).")));
var proAmplifierLabel = React.createElement(React.Fragment, null,
    "For use with amplifier ",
    React.createElement(Help, null, "HCR\u2122 Pro RNA-ISH kits require matching HCR\u2122 HiFi Probe and HCR\u2122 Pro Amplifier systems. HCR\u2122 Pro Amplifiers are available in X1\u2013X10, and the HCR\u2122 HiFi Probe and HCR\u2122 Pro Amplifier in the kit always use matching systems. The same HCR\u2122 HiFi Probe can also be used with the matching HCR\u2122 Gold Amplifier to perform HCR\u2122 Gold RNA-FISH."));
var numberOfBindingSites = React.createElement(React.Fragment, null,
    "# of binding sites ",
    React.createElement(Help, null,
        React.createElement("p", null, "Standard (default): up to 20 binding sites on the target RNA. Recommended for most targets and sample types."),
        React.createElement("p", null, "Boosted: up to 40 binding sites on the target RNA. Recommended for targets and/or samples where a signal boost is desired (e.g., single-molecule imaging of low-abundance targets)."),
        React.createElement("p", null, "Special: for short targets (e.g., miRNA) that can accommodate only 1 binding site.")));
var legacyProbeSetScaleLabel = React.createElement(React.Fragment, null,
    "Scale ",
    React.createElement(Help, null,
        "The standard reaction concentration of each HCR\u2122 Probe (v3.0) is 4 nM. The HCR\u2122 Probe (v3.0) scale depends on the reaction volume and the number of experiments. For example, for a 100 \u00B5L reaction volume, each experiment will require 0.4 pmol of each probe, so 200 pmol probe scale corresponds to 500 experiments.",
        React.createElement("br", null),
        React.createElement("br", null),
        "For the following sample types, recommended reaction volumes are:",
        ProbeSetForm.experimentVolumeTable));
var ComponentPriceDisplay = /** @class */ (function (_super) {
    __extends(ComponentPriceDisplay, _super);
    function ComponentPriceDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComponentPriceDisplay.prototype.render = function () {
        var _this = this;
        return React.createElement(UiConfigContext.Consumer, null, function (uiConfig) {
            return React.createElement(React.Fragment, null,
                React.createElement(Loader, { active: _this.props.loading, inline: true, size: 'mini' }),
                "\u00A0",
                _this.props.effectivePriceCents !== undefined && _this.props.listPriceCents !== undefined ?
                    uiConfig.authenticated ?
                        _this.props.effectivePriceCents === _this.props.listPriceCents ?
                            React.createElement("div", null,
                                "Price: $",
                                formatMonetaryDecimal(_this.props.effectivePriceCents)) :
                            React.createElement("div", null,
                                React.createElement("div", { style: {
                                        textDecoration: 'line-through',
                                        textAlign: "right",
                                        fontWeight: 100
                                    } },
                                    "List: $",
                                    formatMonetaryDecimal(_this.props.listPriceCents)),
                                React.createElement("div", { style: { textAlign: "right" } },
                                    "Academic: $",
                                    formatMonetaryDecimal(_this.props.effectivePriceCents))) :
                        React.createElement("div", null,
                            "List: $",
                            formatMonetaryDecimal(_this.props.effectivePriceCents)) :
                    React.createElement("div", null, "Price: (pending)"));
        });
    };
    return ComponentPriceDisplay;
}(React.PureComponent));
export { ComponentPriceDisplay };
export var cleanUpRnaSeq = function (s) {
    return s.toUpperCase()
        .replace(/G/g, 'g')
        .replace(/T/g, 'U')
        .replace(/\s/g, '');
};
export var noAccessionsMsg = 'None: please check that your sequence matches';
export var calculateNumOfSamplesForProbeSet = function (valuePmol) {
    return Math.round(valuePmol / 4);
};
export var calculateNumOfSlidesForProbeSet = function (valuePmol) {
    return Math.round(valuePmol / 2);
};
//# sourceMappingURL=ProbeSetForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/ProbeSetForm.js
// module id = 20
// module chunks = 0